import React from "react"
import { Question, SubHeader } from "utils/RoutingInfoStyles"
import { AnswerList, SkippableAnswer, SkippedAnswerDisplay } from "./Answers"
import { AnythingElseOptions } from "../../utils/AnythingElseOptions"

type AnythingElseProps = {
  subHeader: string
  questionKey: string
  skipFields?: Array<string>
  answer: string
  additionalTopicsShared?: Array<string>
}

export function AnythingElseJourneyAnswer({
  subHeader,
  questionKey,
  skipFields,
  answer,
  additionalTopicsShared
}: AnythingElseProps): JSX.Element {
  if (skipFields?.includes(questionKey) || (!answer && !additionalTopicsShared)) {
    return (
      <>
        <SubHeader>{subHeader}</SubHeader>
        <SkippedAnswerDisplay />
      </>
    )
  }

  const isHistoricalAnswer = answer && !additionalTopicsShared

  return (
    <>
      <SubHeader>{subHeader}</SubHeader>
      {isHistoricalAnswer ? (
        <>
          <Question>Is there anything else you’d like to share?</Question>
          {answer}
        </>
      ) : (
        <>
          <Question>Topics shared</Question>
          <AnswerList optionTitles={AnythingElseOptions} answers={additionalTopicsShared} />
          <Question>More detail</Question>
          {answer}
        </>
      )}
    </>
  )
}

type AnythingElseMedicalProps = {
  subHeader: string
  questionKey: string
  skipFields?: Array<string>
  answer: string
}

export function AnythingElseMedicalAnswer({
  subHeader,
  questionKey,
  skipFields,
  answer
}: AnythingElseMedicalProps): JSX.Element {
  return (
    <>
      <SubHeader>{subHeader}</SubHeader>
      <Question>Is there anything else you’d like to share?</Question>
      <SkippableAnswer questionKey={questionKey} skipFields={skipFields}>
        {answer}
      </SkippableAnswer>
    </>
  )
}
